<template>
<div>
    <div v-if="data">
        <h1 class="pt-2 text-sm"> {{$t('form.echange.sous_garantie_echangeable')}} </h1>
        <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
            <div class="items-center md:flex">
                <img class="w-full mb-3 md:w-auto md:h-32" src="https://disticloudfiles.net/img/savinfo/default/echange.webp" alt="">
                <div class="ml-3">
                    <div class="my-1 text-xl font-semibold" v-html="textContent"></div>
                </div>
            </div>
        </div>
        <div v-if="data.qrcode" class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
            <div class="items-center md:flex">
                <img test-id="qrcode-img" class="w-full md:h-40 md:w-auto" :src="data.qrcode" />
                <div class="mt-4 md:mt-0 md:ml-4">
                    <div>
                        <h1 class="text-sm font-light">{{$t('form.echange.numero_de_dossier')}}</h1>
                        <h1 class="text-lg font-bold">{{data.num_dossier}}</h1>
                    </div>
                    <div class="mt-3">
                        <h1 class="mb-2 text-sm font-light">{{$t('form.echange.telecharger_le_qrcode')}}</h1>
                        <a class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-700 hover:bg-green-700 rounded-xl" :href="data.qrcode" target="_blank" test-id="btn-download-qr-code">
                            <i class="mr-1 fas fa-download"></i> {{$t('form.echange.telecharger')}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'

export default {
    name: 'echange',
    extends: FormCardExtension,

    computed: {
        textContent() {
            if (this.data.texte) {
                return this.$tt(this.data.texte)
            } else if (this.$formTool.getFormData('buy-online')) {
                if (this.$formTool.getFormData('buy-online') == 'shop') {
                    return this.$tt('Apporter le produit en magasin muni du document suivant')
                }

                if (this.$formTool.getFormData('buy-online') == 'online') {
                    return this.$tt('Veuillez contacter le site vendeur pour la gestion de votre SAV')
                }
            }
            return this.$tt('Apporter le produit en magasin muni du document suivant')
        }
    },

    async mounted() {
        this.data = JSON.parse(this.$formTool.getFormData('set-case'))
        this.data.texte = await apiService.text('title_echange', this.$formTool.getFormData('proc').id, this.data.id_case)
        if (this.data.get_transport == 1) {
            this.nextBlock = this.$formTool.blockData(this.$options.name).next.transport
        } else (
            this.nextBlock = this.$formTool.blockData(this.$options.name).next.noTransport
        )
        this.emitChange()
    },
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/EchangeCard.vue